import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../../redux/filters";
import { useHistory, useParams } from "react-router-dom";
import { Chip } from "@material-ui/core";

export default function TopFilterButton(props) {
  const { value } = props;
  const [clicked, setClicked] = useState(false);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const filters = useSelector((state) => state.filters.value);
  const dispatch = useDispatch();
  const history = useHistory();
  let { tab, query } = useParams();

  // useEffect(() => {
  //   const filterArray = filters?.Sector?.split("|");

  //   const filterPresent = filterArray?.find((item) => item === value?.Sector);
  //   setClicked(
  //     filterPresent
  //       ? true
  //       : filters?.Search_type === value?.Search_type &&
  //         !filters?.Sector &&
  //         value.Title === "Theme Result"
  //       ? true
  //       : false
  //   );
  // }, [filters]);

  return (
    <Chip
      label={
        <>
          {" "}
          <span
            style={{
              fontWeight: "bold",
              paddingRight: "10px",
              color: "#0040ff",
            }}
          >
            {value?.Count}
          </span>
          {value?.Title}{" "}
        </>
      }
      style={{
        height: "50px",
        borderRadius: "35px",
        border: "solid 1px #979797",
        backgroundColor: clicked ? "#0040ff" : "#FFFFFF",
        fontFamily: "Overpass",
        fontsize: "14px",
        color: clicked ? "#FAFAFA" : "#808080",
        textTransform: "unset",
        cursor: "pointer",
        textTransform: "capitalize",
        margin: "10px 10px",
        padding: "0 10px",
      }}
      onClick={() => {
        if (value?.Sector === "ALL") {
          let newState = { ...filters };
          delete newState?.Sector;
          dispatch(
            setFilters({
              ...newState,
              Search_type: value?.Search_type,
            })
          );
        } else {
          dispatch(
            setFilters(
              filters?.Sector
                ? {
                    ...filters,
                    Sector: `${filters.Sector}|${value?.Sector}`,
                    Search_type: value?.Search_type,
                  }
                : {
                    ...filters,
                    Sector: value?.Sector,
                    Search_type: value?.Search_type,
                  }
            )
          );
        }

        history.push(`/search-results/${query}/${tab}`);
      }}
    ></Chip>
  );
}
